import useLoadingStore from "../store/useLoadingStore";
import useModalStore from "../store/useModalStore";
import i18n from "i18next";

import { basename, isProduction } from '../setting';
import feWriteLog from './feWriteLog';

const withErrorHandling = (fn, t) => {
    const { setLoading } = useLoadingStore.getState();
    const { openModalInfo } = useModalStore.getState();

    const isAdminPage = window.location.pathname.startsWith(`/${basename}/${i18n.language}/admin/`);

    return async (...args) => {
        try {
            setLoading(true);
            const response = await fn(...args);
            setLoading(false);
            return response;
        } catch (error) {
            feWriteLog(`Error: ${error.message}`);
            if (error.message === "Unauthorized") {
                if (isAdminPage) {
                    openModalInfo({
                        title: i18n.t("error:unauthorized_admin.title"),
                        text: i18n.t("error:unauthorized_admin.message"),
                    });
                } else {
                    openModalInfo({
                        id: isProduction ? "pre_auth_error_expiry" : "pre_auth_uat_error_expiry",
                        title: i18n.t("error:unauthorized.title"),
                        text: i18n.t("error:unauthorized.message"),
                    });
                }
            } else if (error.message === "Unauthorized Signin") {
                if (isAdminPage) {
                    openModalInfo({
                        title: i18n.t("error:unauthorized_admin_signin.title"),
                        text: i18n.t("error:unauthorized_admin_signin.message"),
                    });
                } else {
                    openModalInfo({
                        id: isProduction ? "pre_auth_error_unauthorized" : "pre_auth_uat_error_unauthorized",
                        title: i18n.t("error:unauthorized_signin.title"),
                        text: i18n.t("error:unauthorized_signin.message"),
                    });
                }
            } else if (error.message === "Unauthorized Wrong DOB") {
                openModalInfo({
                    id: isProduction ? "pre_auth_error_wrong_dob" : "pre_auth_uat_error_wrong_dob",
                    title: i18n.t("error:unauthorized_wrong_dob.title"),
                    modalInfoButtonText: i18n.t("error:unauthorized_wrong_dob.button"),
                    modalInfoPrimaryButtonStyleChangeToDanger: true,
                });
            } else if (error.message === "Network Error") {
                openModalInfo({
                    id: isProduction ? "pre_auth_error_network" : "pre_auth_uat_error_network",
                    title: i18n.t("error:network.title"),
                    text: i18n.t("error:network.message"),
                });
            } else {
                openModalInfo({
                    id: isProduction ? "pre_auth_error_unknown" : "pre_auth_uat_error_unknown",
                    title: i18n.t("error:unknown.title"),
                    text: i18n.t("error:unknown.message"),
                });
            }
            setLoading(false);
            // Handle the error here. This could involve logging the error, displaying
            // an error message to the user, or something else.
        }
    };
};

export default withErrorHandling;